import axios, { AxiosInstance } from 'axios';
import { getHostBaseUrl } from 'utils/browserUtil';

export const axiosInstance: AxiosInstance = axios.create({
  baseURL: getHostBaseUrl(),
  withCredentials: true,
});
